<template>
  <div class="container">
    <div class="wrap">
      <div class="nav">
        <p class="navTitle clear">往届回顾</p>
        <p class="navDesc clear">REVIEW OF PREVIOUS SESSIONS</p>
        <div class="list">
          <img class="listItr" :src="nav.pic" alt="介绍图" />
          <div class="listNav">
            <p class="listNavTitle clear">
              {{ nav.title }}
              <span class="listNavTime">{{ nav.time }}</span>
            </p>
            <p class="listNavDesc clear">{{ nav.desc }}</p>
          </div>
        </div>
      </div>
      <Btn :navArr="IscReview_2023" :style="styleBtn" @fetchNav="fetchNav" />
    </div>
    <div class="line clear">
      <img
        v-if="year >= 2013"
        class="lineTagL"
        src="https://s2.ssl.qhres2.com/static/9d46709069b428df.svg"
        alt="历史回顾点"
        @click="toJumpTag(year + 1)"
      />

      <p v-if="year === 2022" class="lineTagLNav">
        <span class="lineTagLTitle">2023</span>
        <br />
        <span class="lineTagLDesc">盛幕即启</span>
      </p>
      <span v-else-if="year < 2022" class="lineTagLNav">{{ year + 1 }}</span>
      <img
        class="lineTag"
        src="https://s2.ssl.qhres2.com/static/9d46709069b428df.svg"
        alt="历史回顾点"
        @click="toJumpTag(year)"
      />
      <span class="lineTagTitle">{{ year }}</span>
      <img
        v-if="year > 2013"
        class="lineTagS"
        src="https://s2.ssl.qhres2.com/static/9d46709069b428df.svg"
        alt="历史回顾点"
        @click="toJumpTag(year - 1)"
      />
      <span v-if="year > 2013" class="lineTagSTitle">{{ year - 1 }}</span>
    </div>
  </div>
</template>

<script setup>
import { IscReview_2023 } from '@/mock/2023isc/data.js'
import Btn from '@/components/common/2023/button.vue'
import { ref } from 'vue'
const year = ref(2022)
const nav = ref(IscReview_2023[0])
const styleBtn = {
  position: 'absolute',
  right: '14px',
  bottom: '81px'
}
function fetchNav(newId) {
  nav.value = IscReview_2023[newId]
  year.value = 2022 - newId
}
function toJumpTag(oldYear) {
  if (oldYear !== 2023 && oldYear !== 2012) {
    year.value = oldYear
    nav.value = IscReview_2023[2022 - oldYear]
  }
}
</script>

<style lang="scss" scoped>
.clear {
  margin: 0;
}
.wrap {
  position: relative;
  width: 100%;
  height: 879px;
  padding: 36px 44px 81px;
  background: url('https://p2.ssl.qhimg.com/t01f822425044a702a7.png') center;
  background-size: cover;
  overflow: hidden;
}
.nav {
  margin: auto;
  position: relative;
  text-align: center;
  &Title {
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    color: #ffffff;
  }
  &Desc {
    font-size: 12px;
    line-height: 20px;
    color: #ffffff;
    margin: 6px 0 32px;
  }
}
.list {
  margin: 0 0 47px 0;
  border: 2px solid #ffffff;
  &Itr {
    width: 100%;
  }
  &Nav {
    min-height: 292px;
    padding: 11px 16px;
    background: #0a6857;
    text-align: left;
    &Title {
      font-size: 16px;
      font-weight: bold;
      line-height: 26px;
      color: #ffffff;
    }
    &Time {
      float: right;
      margin-top: 7px;
      font-size: 12px;
      line-height: 14px;
      color: rgba(255, 255, 255, 0.5);
    }
    &Desc {
      font-size: 14px;
      line-height: 24px;
      color: rgba(255, 255, 255, 0.8);
      margin-top: 16px;
    }
  }
}
.line {
  position: relative;
  top: -235px;
  width: 100%;
  border-bottom: 1px dashed #00ab7a;
  &Tag {
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 24px;
    height: 24px;
    &Title {
      position: absolute;
      top: 18px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 32px;
      font-weight: bold;
      line-height: 32px;
      color: #00ab7a;
    }
  }
  &TagL {
    position: absolute;
    top: -8px;
    left: 36px;
    width: 16px;
    height: 16px;
    &Nav {
      position: absolute;
      top: 13px;
      left: 14px;
      font-size: 24px;
      line-height: 32px;
      color: rgba(0, 171, 122, 0.6);
      margin: 0;
      font-weight: bold;
    }
    &Title {
      font-weight: bold;
      color: rgba(173, 173, 173, 0.6);
    }
    &Desc {
      font-weight: bold;
      font-size: 20px;
      line-height: 28px;
      color: rgba(173, 173, 173, 0.6);
    }
  }
  &TagS {
    position: absolute;
    top: -8px;
    right: 36px;
    width: 16px;
    height: 16px;

    &Title {
      position: absolute;
      top: 13px;
      right: 14px;
      font-size: 24px;
      font-weight: bold;
      line-height: 32px;
      color: rgba(0, 171, 122, 0.6);
    }
  }
}
</style>
